module.exports = __webpack_public_path__ + "static/media/profile_placeholder.16b74247.png";